<div fxLayout="row" fxLayoutAlign="center center">
  <div fxLayout="column" fxFlex="70%" fxFlex.sm="80%" fxFlex.md="80%" fxFlex.xs="90%"
    fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
    <br />
    <br />
    <h1 *ngIf="ready" i18n="@@learner-dashboard-header" name="learner-dashboard-header" class="mat-h1"><b>Dashboard</b></h1>
    <ng-container *ngIf="ready">
    <ng-container *ngIf="!hasAssignedCourses">
      <p i18n="@@learner-home-no-courses" class="no-course-info" id="no-course-info" name="no-course-info">You have no courses assigned at the moment. Please ask your tutor about your next steps. They may wish you to take a screener before you begin a course.</p>
    </ng-container>
      <ng-container *ngIf="courses?.length == 5 || courses?.length == 4 else inlineCourses">
        <div fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="5%">
          <ng-container *ngIf="ready">
            <ng-container *ngFor="let course of courses; trackBy: trackByFunction; let i = index; count as c">
              <ng-container *ngIf="i < 2">
                <ng-container *ngTemplateOutlet="defaultTemplate; context: course"></ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <div fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="5%">
          <ng-container *ngIf="ready">
            <ng-container *ngFor="let course of courses; trackBy: trackByFunction; let i = index; count as c">
              <ng-container *ngIf="i >= 2">
                <ng-container *ngTemplateOutlet="defaultTemplate; context: course"></ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #inlineCourses>
        <div fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="5%">
          <ng-container *ngIf="ready">
            <ng-container *ngFor="let course of courses; trackBy: trackByFunction; let i = index; count as c">
              <ng-container *ngTemplateOutlet="defaultTemplate; context: course"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
    </ng-container>
    <app-browser-note></app-browser-note>
  </div>
</div>

<ng-template #defaultTemplate
 let-courseId="id" 
 let-courseInfo="info"
 let-courseName="name"
 let-courseStarted="started"
 let-courseIconPath="iconPath"
 let-screenerResults="screenerResult"
 let-metadatas="metadatas">
  <mat-card fxLayout="row wrap" fxLayoutAlign="center center" class="mat-elevation-z4">
    <ng-container *ngIf="courseId != 10">
      <img mat-card-image (click)="navigateToCourse(courseId, false, courseIconPath)" class="course-img" src={{courseIconPath}}
        alt={{courseName}}>
    </ng-container>
    <ng-container *ngIf="courseId == 10">
      <img mat-card-image (click)="navigateToCourse(courseId, true, courseIconPath)" class="course-img" src={{courseIconPath}}
        alt={{courseName}}>
    </ng-container>
    <div class="float-button">
      <ng-container *ngIf="courseId != 10 && hasAssignedCourses">
        <button i18n="@@course-status-start-btn" name="course-status-start-btn" mat-raised-button color="primary"
          (click)="navigateToCourse(courseId, false, courseIconPath)" *ngIf="!courseStarted">Start</button>
        <button i18n="@@course-status-cont-btn" name="course-status-cont-btn" mat-raised-button color="primary"
          (click)="navigateToCourse(courseId, false, courseIconPath)" *ngIf="courseStarted">Continue</button>
      </ng-container>
      <ng-container *ngIf="courseId == 10 && hasAssignedCourses">
        <button i18n="@@course-status-start-btn" name="course-status-start-btn" mat-raised-button color="primary"
          (click)="navigateToCourse(courseId, true, courseIconPath)" *ngIf="!courseStarted">Start</button>
        <button i18n="@@course-status-cont-btn" name="course-status-cont-btn" mat-raised-button color="primary"
          (click)="navigateToCourse(courseId, true, courseIconPath)" *ngIf="courseStarted">Continue</button>
      </ng-container>
      <ng-container *ngIf="!hasAssignedCourses && screenerResults === null && metadatas !== null">
        <button i18n="@@course-status-start-btn" name="course-status-start-btn" mat-raised-button color="primary"
          (click)="saveScreenerDetails(metadatas)" *ngIf="!courseStarted">Launch screener</button>
      </ng-container>
    </div>
    <mat-progress-bar mat-card-image mode="determinate" value="60"></mat-progress-bar>
    <mat-card-content fxFlex="100%" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
      <h3 *ngIf="!hasAssignedCourses && screenerResults === null" name="course-name" class="p-10"><b>{{courseName}}</b></h3>
      <mat-expansion-panel *ngIf="hasAssignedCourses || screenerResults !== null" class="mat-elevation-z0" [expanded]="screenerResults != null && !hasAssignedCourses">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 name="course-name"><b>{{courseName}}</b></h3>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p *ngIf="hasAssignedCourses else screenerResult" class="course-info" name="course-info" [innerHTML]="courseInfo"></p>
        <ng-template #screenerResult>
          <p i18n="@@screener-result-level" name="screener-result-level"><br />Your screener answers suggested
              that you were working towards
              <span>{{screenerResults?.overallResult | titlecase}}</span>
              in {{courseName}}.
          </p>
          <div fxShow fxHide.xs fxLayout="column" fxLayoutAlign="start stretch" fxFlexAlign="center" fxFlexAlign.xs="center" class="ml-20">
              <span i18n="@@screener-result-date-completed" name="screener-result-date-completed"
                  class="date-completed text-grey">Date completed:
                  <i>{{screenerResults?.dateCompleted | date:'d MMM y'}}</i></span>
              <p i18n="@@screener-result-total-time" name="screener-result-total-time"
                  class="total-time text-grey" fxLayout.xs="column" fxLayoutAlign.xs="start center">
                  <span>Total time taken: </span><i fxFlex.xs="100%" fxFlexAlign.xs="center">{{screenerResults?.totalTime}}</i></p>
          </div>
          <div fxHide fxShow.xs>
              <span i18n="@@screener-result-date-completed" name="screener-result-date-completed"
                  class="date-completed text-grey">Date completed:
                  <i>{{screenerResults?.dateCompleted | date:'d MMM y'}}</i></span>
              <p i18n="@@screener-result-total-time" name="screener-result-total-time"
                  class="total-time text-grey">
                  <span>Total time taken: </span><i>{{screenerResults?.totalTime}}</i></p>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-card-content>
  </mat-card>
</ng-template>